/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum edsn_organizationalunit_edsn_wijzigingtype {
    TOEVOEGEN = 'Toevoegen',
    WIJZIGEN = 'Wijzigen',
    VERWIJDEREN = 'Verwijderen',
}
